import Vue from "vue";
import App from "./App.vue";
import VueGtm from "@gtm-support/vue2-gtm";

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");


Vue.use(VueGtm, {
  id: 'GTM-K7Q5NF3',
});


Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  });
  return formatter.format(value);
});